
import type { PropOptions } from 'vue';
import Vue from 'vue';
import PortfolioSectionField from '@/components/partials/public-portfolio/PortfolioSectionField/PortfolioSectionField.vue';
import { getSalesExperinceConfig } from '@/components/partials/public-portfolio/PublicPortfolioSalesExperience/constants';
import type { SectionMode } from '~/components/partials/public-portfolio/types';
import type { CurrentUser } from '~/types/graphql';

export default Vue.extend({
  name: 'PublicPortfolioSalesExperience',
  components: { PortfolioSectionField },
  props: {
    mode: { type: String, default: 'view' } as PropOptions<SectionMode>,
    user: { type: Object, default: () => ({} as CurrentUser) } as PropOptions<CurrentUser>,
  },
  computed: {
    fields() {
      return getSalesExperinceConfig({ user: this.user });
    },
  },
  methods: {
    handleEdit(fieldName: string): void {
      if (!fieldName) {
        this.$modal.showWithRoute({ custom: this.$constants.dynamicModals.PORTFOLIO_SALES_EXPERIENCE_MODAL });
        return;
      }

      this.$modal.showWithRoute(
        { custom: this.$constants.dynamicModals.PORTFOLIO_SALES_EXPERIENCE_MODAL },
        { field_key: fieldName },
      );
    },
  },
});
